import React, { Suspense } from 'react';
import { getRegisteredComponent, registerComponent } from './componentRegistry';

const ComparisonChartLazy = React.lazy(() => import('./ComparisonChartBlock'));
registerComponent('comparison_chart', ComparisonChartLazy);

function BlockFallback() {
  return (
    <div
      style={{
        padding: 16,
        marginTop: 8,
        borderRadius: 12,
        background: '#f1f5f9',
        color: '#475569',
        fontSize: 13,
      }}
    >
      Chargement du composant…
    </div>
  );
}

/**
 * @param {{ blocks: Array<{ id?: string, type: string, data: unknown }> }} props
 */
export default function GenUIMessagePart({ blocks }) {
  if (!blocks || !blocks.length) return null;

  return (
    <div className="genui-blocks">
      {blocks.map((b, idx) => {
        const Comp = getRegisteredComponent(b.type);
        const key = b.id || `${b.type}-${idx}`;
        if (!Comp) {
          return (
            <div key={key} className="genui-block genui-block--unknown" style={{ fontSize: 13, color: '#94a3b8' }}>
              Type GenUI non enregistré : {b.type}
            </div>
          );
        }
        return (
          <div key={key} className="genui-block">
            <Suspense fallback={<BlockFallback />}>
              <Comp data={b.data} />
            </Suspense>
          </div>
        );
      })}
    </div>
  );
}
